import { useEffect, useState } from 'react';
import { documentType, type ProviderType, providerType } from '@repo/shared/types';
import type { LinkedDocument } from '@repo/shared/types';
import { useGetLoanDocument } from '@repo/api/endpoints/loan';

export const useDocumentsByProvider = () => {
  const [isGetLoanDocumentEnable, setIsGetLoanDocumentEnable] = useState(false);
  const {
    data: documentData,
    isFetching: isDocumentDataFetching,
    refetch,
    isError,
  } = useGetLoanDocument(isGetLoanDocumentEnable);

  const isPragmaDocumentType = (doc: LinkedDocument) => doc.type === documentType.enum.pragma;

  const isPragmaDocFetchError = (doc: LinkedDocument) => isPragmaDocumentType(doc) && isError;

  const documentsByProvider = (documents: LinkedDocument[], currentProvider: ProviderType) =>
    currentProvider === providerType.enum.pragma
      ? documents.filter((doc) => isPragmaDocumentType(doc))
      : documents;

  const handleDownloadDocument = (loanId: number, currentProvider: ProviderType) => {
    setIsGetLoanDocumentEnable(true);
    refetch({
      loanId: loanId.toString(),
      provider: currentProvider,
      requestId: crypto.randomUUID(),
    });
  };

  useEffect(() => {
    if (documentData && documentData instanceof Blob) {
      const url = window.URL.createObjectURL(documentData);
      window.open(url, '_blank');
    }
  }, [documentData]);

  return {
    isPragmaDocumentType,
    documentsByProvider,
    handleDownloadDocument,
    isPragmaDocFetchError,
    isDocumentDataFetching,
  };
};
